import { Table } from 'ui/table';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { PROJECT_STATS_TABLE_COLUMNS } from '../constants';
import type { ProjectStatsTableProps } from '../types';

export const ProjectStatsTable = ({ projects }: ProjectStatsTableProps) => {
  const {
    currentPage,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: projects,
    sortedBy: 'id',
  });

  return (
    <>
      <Table>
        <TableHeader
          columns={PROJECT_STATS_TABLE_COLUMNS}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
          sortDirection={sortDirection}
          sortedBy={sortedBy}
        />
        <TableRows columns={PROJECT_STATS_TABLE_COLUMNS} rows={rows} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};
